import SelectInventoryProduct from './SelectInventoryProduct';

export default SelectInventoryProduct;
